<template>
  <div class="edit-sheet-field-rules">
    <side-menu class="side-menu" :activeMenu.sync="activeMenu"></side-menu>
    <main-content
      ref="mainContent"
      class="main-content"
      :menu="activeMenu"
      :sheetFields="sheetFields"
      :sheet="sheet.data"
    ></main-content>
  </div>
</template>

<script>
import SideMenu from "./side-menu"
import MainContent from "./main-content"
import { updateSheetRule } from "@/api/sheet/sheet"

export default {
  name: "edit-sheet-field-rules",
  components: {
    "side-menu": SideMenu,
    "main-content": MainContent
  },
  props: {
    sheet: Object,
    controlsMap: Object
  },
  data() {
    return {
      activeMenu: "hide",
      loading: true
    }
  },
  computed: {
    sheetFields() {
      if (!this.sheet.data.controls) return []
      return this.sheet.data.controls.map(i => {
        return {
          label: i.name,
          value: i._cid,
          type: i._type
        }
      })
    }
  },
  methods: {
    init() {
      this.$refs.mainContent.initial({
        rules: this.sheet.data.rules,
        uniqueRules: this.sheet.data.uniqueRules,
        selfRules: this.sheet.data.selfRules
      })
      this.loading = false
    },
    submit() {
      let editedsheet = this.$refs.mainContent.output()
      const loading = this.$loading({
        lock: true,
        text: "保存中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      })
      return updateSheetRule(this.sheet.data.sheetId, editedsheet)
        .then(res => {
          if (res.data) {
            this.$message.success("字段规则更新成功")
            this.$refs.mainContent.selectRule(-1)
          }
          return res
        })
        .finally(() => {
          loading.close()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-sheet-field-rules {
  display: flex;
  .side-menu {
    flex-basis: 240px;
    height: calc(100vh - 55px);
    box-sizing: border-box;
  }
  .main-content {
    flex: 1 1;
    background-color: #fff;
  }
}
</style>
